<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض الدرس </CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>الكورس</th>
                    <td>{{ selectedCourse.name }}</td>
                  </tr>
                  <tr>
                    <th>الوحدة</th>
                    <td>{{ selectedSection.name }}</td>
                  </tr>
                </table>
            </div>
            <div class="col-md-6">
              <table class="table table-bordered">
                  <tr>
                    <th>العنوان</th>
                    <td>{{ lesson.title }}</td>
                  </tr>
                  <tr>
                    <th> العنوان بالعربي</th>
                    <td>{{ lesson.title_ar }}</td>
                  </tr>
                  <tr>
                    <th>الوصف</th>
                    <td>{{ lesson.description }}</td>
                  </tr>
                  <tr>
                    <th>الوصف بالعربي</th>
                    <td>{{ lesson.description_ar }}</td>
                  </tr>
                   <tr>
                    <th>حاله العرض</th>
                    <td>{{ (lesson.free ? 'مجاني' : 'مدفوع') }}</td>
                  </tr>
                </table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <video ref="videoRef" src="" id="video-container" controls></video>
            </div>
          </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
export default {
  name: 'ShowSection',
  data () {
    return {
      lesson: {},
      selectedCourse: '',
      selectedSection: '',
      video: ''
    }
  },
  created () {
    this.$http
      .get(`${this.$hostUrl}lessons/${this.$route.params.id}/edit`)
      .then((response) => {
        this.lesson = response.data.data.lesson
        this.selectedCourse = {
          id: this.lesson.section.course.id,
          name: this.lesson.section.course.name_ar
        }
        this.selectedSection = {
          id: this.lesson.section.id,
          name: this.lesson.section.name_ar
        }
        this.$refs.videoRef.src = this.lesson.video_full_path
      })
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/lessons' })
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
</style>
